<template>
  <div
    v-if="recommendBlogs.length"
    class="c-blogRecommendedList"
  >
    <div class="c-blogRecommendedList_title">このブログを見た人にオススメ</div>
    <div
      v-for="(recommendBlog, index) in recommendBlogs"
      :key="index"
      class="c-blogRecommendedList_contents"
    >
      <nuxt-link :to="`/blogs/${recommendBlog.userId}/${recommendBlog.id}`">
        <div
          class="c-blogRecommendedList_heading"
          :class="{ 'c-blogRecommendedList_heading-hasImg' : recommendBlog.coverImageUrl }"
        >
          <div>
            <div class="c-blogRecommendedList_blogTitle">
              {{ $util.truncate(recommendBlog.title, maxTitle) }}
              <span class="c-blogRecommendedList_kind">
                <coconala-icon
                  :name="kindIconName(recommendBlog.kind)"
                  :size="kindIconSize(recommendBlog.kind)"
                />
                {{ kindText(recommendBlog.kind) }}
              </span>
            </div>
            <div class="c-blogRecommendedList_category">{{ recommendBlog.categoryName }}</div>
          </div>
          <img
            v-if="recommendBlog.coverImageUrl"
            :src="recommendBlog.coverImageUrl"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div
          v-if="isPC"
          class="c-blogRecommendedList_blogDescription"
        >{{ $util.truncate(recommendBlog.summary, maxSummary) }}</div>
        <div
          v-if="recommendBlog.price > 0"
          class="c-blogRecommendedList_price"
        >{{ $util.numberWithDelimiter(recommendBlog.price) }}円</div>
        <div class="c-blogRecommendedList_writer">
          <c-user-icon-v2
            :file-path="getUser(recommendBlog.userId).userIconPath"
            :size="24"
            v-if="getUser(recommendBlog.userId)"
          />
          <div class="c-blogRecommendedList_writerDetail">
            <div
              class="c-blogRecommendedList_writerName"
              v-if="getUser(recommendBlog.userId)"
            >{{ getUser(recommendBlog.userId).name }}</div>
            <div class="c-blogRecommendedList_postDate">{{ $util.dayjs.unix(recommendBlog.openedAt).format('YYYY/MM/DD HH:mm') }}</div>
          </div>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>
<script>
// vuex
import { mapGetters, mapState } from 'vuex'

const MAX_TITLE_PC = 60
const MAX_SUMMARY_PC = 100
const MAX_TITLE_SP = 44
const MAX_SUMMARY_SP = 60

export default {
  name: 'BlogRecommendedList',
  computed: {
    ...mapGetters('auth', ['isFromCoconalaApp']),
    ...mapGetters('ui', ['isPC']),
    ...mapState('pages/blogs/constants', ['KIND']),
    ...mapState('pages/blogs/user', ['recommendBlog']),
    maxTitle() {
      return this.isPC ? MAX_TITLE_PC : MAX_TITLE_SP
    },
    maxSummary() {
      return this.isPC ? MAX_SUMMARY_PC : MAX_SUMMARY_SP
    },
    recommendBlogs() {
      if (!this.recommendBlog.recommendBlogsList.length) {
        return []
      }
      if (this.isFromCoconalaApp) {
        return this.recommendBlog.recommendBlogsList.filter(blog => blog.price <= 0)
      } else {
        return this.recommendBlog.recommendBlogsList
      }
    }
  },
  methods: {
    getUser(userId) {
      return this.recommendBlog.blogUsersList.find(user => {
        return user.id === userId
      })
    },
    isKindNormal(kind) {
      return kind === this.KIND.NORMAL
    },
    isKindContents(kind) {
      return kind === this.KIND.CONTENTS
    },
    isKindAnnounce(kind) {
      return kind === this.KIND.ANNOUNCE
    },
    kindIconName(kind) {
      if (this.isKindNormal(kind)) return 'blog-article'
      if (this.isKindContents(kind)) return 'blog-content'
      if (this.isKindAnnounce(kind)) return 'blog-announce'
      return 'blog-article'
    },
    kindIconSize(kind) {
      if (this.isKindNormal(kind)) return '10px'
      if (this.isKindContents(kind)) return '10px'
      if (this.isKindAnnounce(kind)) return '9px'
      return '12px'
    },
    kindText(kind) {
      return this.$store.getters['pages/blogs/constants/kindText'](kind)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blogRecommendedList {
  &_title {
    padding-bottom: 12px;
    color: $color-gray-900;
    font-weight: bold;
    font-size: 14px;
  }

  &_kind {
    color: $color-gray-600;
    font-weight: normal;
    font-size: 10px;
  }

  &_category {
    margin: 4px 0 8px;
    color: $color-gray-600;
    font-size: 10px;
  }

  &_contents {
    border-top: 1px solid $color-gray-200;

    &:hover {
      background-color: $color-bg-pale;
    }

    &:last-child {
      border-bottom: 1px solid $color-gray-200;
    }
  }

  &_heading {
    margin: 12px 0;

    &-hasImg {
      display: flex;

      justify-content: space-between;

      img {
        margin-left: 20px;
        width: 112px;
        height: 63px;
        border-radius: 6px;
      }
    }
  }

  &_blogTitle {
    color: $color-gray-900;
    font-weight: bold;
    font-size: 16px;
  }

  &_blogDescription {
    margin: 8px 0;
    color: $color-gray-900;
    font-size: 12px;
  }

  &_price {
    color: $color-gray-900;
    font-size: 12px;
  }

  &_writer {
    display: flex;
    padding: 12px 0;

    align-items: center;
  }

  &_writerDetail {
    margin-left: 8px;
  }

  &_writerName {
    color: $color-gray-900;
    font-size: 11px;
  }

  &_postDate {
    color: $color-gray-600;
    font-size: 10px;
  }
}

@media (max-width: $breakpoint-m) {
  .c-blogRecommendedList {
    padding: 0 16px;

    &_heading {
      &-hasImg {
        img {
          margin-left: 12px;
          width: 100px;
          height: 56px;
        }
      }
    }

    &_blogTitle {
      font-size: 14px;
    }

    &_price {
      font-size: 10px;
    }
  }
}
</style>
